/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const CloseIcon = ({
  className,
  style,
  color = '#6ABAA4',
  size = 23,
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      style={style}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.97 5.657a1 1 0 00-1.414 0L11.314 9.9 7.07 5.657A1 1 0 105.657 7.07l4.242 4.243-4.242 4.242a1 1 0 101.414 1.415l4.242-4.243 4.243 4.243a1 1 0 101.414-1.415l-4.242-4.242L16.97 7.07a1 1 0 000-1.414z"
        fill={color}
      />
    </svg>
  );
};
